<template>
  <div>
    <div v-if="loading" class="ml-4">
      <i class="fas fa-spin fa-circle-notch"></i>
    </div>
    <div v-if="!loading">
      <i
        v-for="(n, i) in rating"
        :key="i"
        :class="n.class"
        @click="submitRating(n.rating)"
        @mouseover="starOver(n.rating)"
        @mouseout="starOut"
      ></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "Rating",
  props: ["order"],
  data() {
    return {
      rating: [],
      loading: false,
    };
  },
  created() {
    for (let i = 1; i <= 5; i++) {
      this.rating.push({
        rating: i,
        class: "far fa-star text-muted pointer",
      });
    }
    if (this.order.rating != null) {
      let orderRating = this.order.rating;
      this.rating.filter((r) => {
        if (r.rating <= orderRating) {
          r.class = "fas fa-star text-warning pointer";
        }
      });
    }
  },
  methods: {
    submitRating: async function (rating) {
      this.loading = true;
      this.$store
        .dispatch("orders/submitRating", {
          order: this.order,
          rating: rating,
        })
        .then((success) => {
          if (success) {
            this.$store
              .dispatch("orders/allRequests", { noLoading: true })
              .then(() => {
                this.loading = false;
              });
          }
        });
    },
    starOver: function (r) {
      this.rating.filter((s) => {
        if (s.rating <= r) {
          s.class = "fas fa-star text-warning pointer";
        } else {
          s.class = "far fa-star text-muted pointer";
        }
      });
    },
    starOut: function () {
      this.rating.filter((s) => {
        s.class = "far text-muted fa-star pointer";
      });
      if (this.order.rating != null) {
        let orderRating = this.order.rating;
        this.rating.filter((r) => {
          if (r.rating <= orderRating) {
            r.class = "fas fa-star text-warning pointer";
          }
        });
      }
    },
  },
};
</script>
<style lang="css">
.pointer {
  cursor: pointer !important;
}
</style>
